
const BlockOne = () => {
  return (
    <div className="bg-[#F4EBDC] w-full justify-center flex py-10">
      <div className="text-[#000000] max-w-[800px]">
        <h1 className="text-3xl md:text-5xl text-center font-custom">Discover the World's </h1>
        <h1 className="text-2xl md:text-5xl text-center font-custom">Wonders with Us</h1>
        <p className="text-lg md:text-2xl text-center mt-8 font-customFontNew px-2">Embark on a journey of a lifetime to breathtaking destinations. Your adventure awaits, filled with unforgettable experiences and cherished memories.</p>
        <div className="flex justify-center">
          <button className="bg-[#FF9D00] px-8 py-4 rounded-full mt-8 text-white font-bold min-w-[220px]">Contact Us</button>
        </div>
      </div>
    </div>
  )
}

export default BlockOne